// extracted by mini-css-extract-plugin
export default {"list":"PassengerDialog_list__pV7gV","current_player":"PassengerDialog_current_player__tFebW"};